import React, { Component } from "react";
import Select from "react-select";

export default class QCTypePicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedOption: "",
			isClearable: true,
			isSearchable: false,
		};
	}

	render() {
		const options = [
			{ value: "Internal", label: "Internal" },
			{ value: "External", label: "External" },
		];

		return (
			<div>
				<Select
					name="form-field-name"
					placeholder="QCType..."
					value={this.state.value}
					onChange={this.props.action}
					isClearable={this.state.isClearable}
					isSearchable={this.state.isSearchable}
					options={options}
				/>
			</div>
		);
	}
}
